export const Prefix = {
  Set: 'S',
  Real: 'R',
  Content: 'C'
} as const
export type Prefix = typeof Prefix[keyof typeof Prefix]

export const BibliographyClass = {
  Set: '1',
  Real: '3',
  Content: '4'
} as const
export type BibliographyClass = typeof BibliographyClass[keyof typeof BibliographyClass]

export const SearchType = {
  Book: 'T',
  Av: 'A',
  Magazine: 'Z'
} as const
export type SearchType = typeof SearchType[keyof typeof SearchType]

export const NarrowTarget = {
  Title: 'title',
  Author: 'author',
  Publisher: 'publisher',
  MaterialFormat: 'materialFormat',
  FreeWord: 'freeWord'
} as const
export type NarrowTarget = typeof NarrowTarget[keyof typeof NarrowTarget]

export const DisplayMethod = {
  Simple: '1',
  Detail: '2',
  DetailAndImage: '3'
} as const
export type DisplayMethod = typeof DisplayMethod[keyof typeof DisplayMethod]

export const SearchTarget = {
  Db: '1',
  Tooli: '2'
} as const
export type SearchTarget = typeof SearchTarget[keyof typeof SearchTarget]

export const BibliographySearchType = {
  Basic: 'basic',
  Alone: 'alone',
  Free: 'free',
  Authority: 'authority',
  Content: 'content'
} as const
export type BibliographySearchType = typeof BibliographySearchType[keyof typeof BibliographySearchType]

export const AloneSearchType = {
  NewPublicationInformationDate: 'newPublicationInformationDate',
  NewPublicationInformationVolume: 'newPublicationInformationVolume',
  CollectionNo: 'collectionNo',
  OrderId: 'orderId',
  Bibliography: 'bibliography',
  Isbn: 'isbn',
  ProductNumber: 'productNumber',
  MagazineCode: 'magazineCode',
  Marc: 'marc'
}
export type AloneSearchType = typeof AloneSearchType[keyof typeof AloneSearchType]

export const AuthoritySearchType = {
  Author: 'author',
  ContentAuthor: 'contentAuthor',
  Subject: 'subject',
  CompleteWorks: 'completeWorks',
  Series: 'series',
  Publisher: 'publisher'
} as const
export type AuthoritySearchType = typeof AuthoritySearchType[keyof typeof AuthoritySearchType]

// toggle-buttonでnullを使用できない、また、APIでも配列要素の型が統一されている方が読みやすく、組み込みメソッドも使いやすい
// よって、nullは文字列で対応
export const CollectionTarget = {
  noCollection: 'null',
  archive: '1',
  order: '2',
  selection: '3'
}
export type CollectionTarget = typeof CollectionTarget[keyof typeof CollectionTarget]

export interface BibliographyFullId {
  prefix: Prefix
  id: number
}

export const defaultBibliographyFullId = (): BibliographyFullId => ({
  prefix: Prefix.Real,
  id: 0
})

export interface BibliographyFullIdWithMarcNo {
  prefix: Prefix
  id?: number
  marcNo?: string
  title?: string
}

export function BibliographyFullIdWithMarcNoToJSON(
  value: BibliographyFullIdWithMarcNo
): any {
  return {
    prefix: value.prefix,
    id: value.id ?? undefined,
    marc_no: value.marcNo ?? undefined,
    title: value.title ?? undefined
  }
}

export const defaultBibliographyFullIdWithMarcNo = (): BibliographyFullIdWithMarcNo => ({
  prefix: Prefix.Real,
  id: undefined,
  marcNo: undefined,
  title: undefined
})

export const CollectionFlag = {
  NotCollection: null,
  Collection: '1',
  OrderOnly: '2',
  SelectionOnly: '3',
  TempBibliography: '4'
}
export type CollectionFlag = typeof CollectionFlag[keyof typeof CollectionFlag]

export const BibliographyDetailRealTabType = {
  Collection: 'collection',
  Reserve: 'reserve',
  Bibliography: 'bibliography',
  Content: 'content',
  Marc: 'marc',
  Image: 'image',
  Tooli: 'tooli'
}
export type BibliographyDetailRealTabType = typeof BibliographyDetailRealTabType[keyof typeof BibliographyDetailRealTabType]

export const BibliographyDetailSetTabType = {
  Volume: 'volume',
  MagazineName: 'magazineName',
  AutoOrder: 'autoOrder',
  Marc: 'marc',
  Management: 'management'
}
export type BibliographyDetailSetTabType = typeof BibliographyDetailSetTabType[keyof typeof BibliographyDetailSetTabType]

export const BibliographySearchSortKey = {
  Title: 'title',
  Kana: 'kana',
  Author: 'author',
  Publisher: 'publisher',
  Published: 'published',
  Subtitle: 'subtitle',
  MaterialFormat: 'material_format',
  Class: 'class',
  Unspecified: ''
}
export type BibliographySearchSortKey = typeof BibliographySearchSortKey[keyof typeof BibliographySearchSortKey]

export const BibliographySearchSortOrder = {
  Asc: 'asc',
  Desc: 'desc',
  Unspecified: ''
}
export type BibliographySearchSortOrder = typeof BibliographySearchSortOrder[keyof typeof BibliographySearchSortOrder]

export const PublishNewArrivalMagazine = {
  Private: '0',
  Public: '1'
}
export type PublishNewArrivalMagazine = typeof PublishNewArrivalMagazine[keyof typeof PublishNewArrivalMagazine]
